import { defineStore } from "pinia";
interface ResponseScanner {
  content: string;
  name?: string;
  file?: string;
  type?: string;
  copied?:boolean
}

export const useScanner = defineStore({
  id: "scanner-store",
  state: () => {
    const response: Array<ResponseScanner> = [];
    return {
      camera_failded: false,
      scanning: false,
      isOpen: false,
      response,
    };
  },
  actions: {
    startScanning() {
      this.response = [];
      this.scanning = true;
    },
    closeModal() {
      this.isOpen = false;
    },
    openModal() {
      this.isOpen = true;
    },
  },
  getters: {},
});
